__turbopack_context__.v({
  "flexColumn": "OjJLlW_flexColumn",
  "requirements": "OjJLlW_requirements",
  "requirements__conversion-factors-wrapper": "OjJLlW_requirements__conversion-factors-wrapper",
  "requirements__conversion-factors-wrapper--block": "OjJLlW_requirements__conversion-factors-wrapper--block",
  "requirements__monthly-goals-wrapper": "OjJLlW_requirements__monthly-goals-wrapper",
  "requirements__note-wrapper": "OjJLlW_requirements__note-wrapper",
  "requirements__note-wrapper--block": "OjJLlW_requirements__note-wrapper--block",
  "skeleton": "OjJLlW_skeleton",
});
